/* eslint-disable react/prop-types */
import React, { useState, useEffect } from "react";
import { Typography, makeStyles, Box } from "@material-ui/core";
import CardComponent from "app/common/CardComponent";
import { useSelector } from "react-redux";
import buildRequestUrl from "lib/requests/requestUtils";
import athenaClient from "lib/axios/clients";
import MainScenarioCardComponent from "./main_scenario_component/MainScenarioCardComponent";
import CustomCompetitorsListComponent from "./CustomCompetitorsListComponent";

const useStyles = makeStyles((theme) => ({
  componentTitle: {
    fontWeight: "bold",
    marginTop: "30px",
    marginLeft: "30px",
    fontSize: "18px",
    [theme.breakpoints.up("xl")]: {
      fontSize: "18px",
    },
  },
  componentSecondTitle: {
    fontWeight: "bold",
    marginTop: "30px",
    marginLeft: "34px",
    marginBottom: "5px",
    fontSize: "18px",
    [theme.breakpoints.up("xl")]: {
      fontSize: "18px",
    },
  },
  borderBarTop: {
    borderTop: "1px solid #e2e2e2",
  },
  CardCompetitorsContainer: {
    height: "100%",
  },
  scrolleableContainer: {
    overflow: "auto",
    "&:focus": {
      outline: "none",
    },
    "&::-webkit-scrollbar": {
      width: "5px",
    },
    "&::-webkit-scrollbar-track": {
      background: "#f1f1f1",
    },

    /* Handle */
    "&::-webkit-scrollbar-thumb": {
      background: "#bbb",
      borderRadius: "5px",
      padding: "1px",
    },

    /* Handle on hover */
    "&::-webkit-scrollbar-thumb:hover": {
      background: "#999",
    },
  },
}));

export default function ProductComparatorComponent() {
  const classes = useStyles();
  const [
    baseCompetitorScenarioData,
    setBaseCompetitorScenarioData,
  ] = useState();
  const selectedScenarioSlice = useSelector(
    (state) => state.scenarios.selectedScenario
  );
  const mainScenarioId = baseCompetitorScenarioData
    ? baseCompetitorScenarioData?.scenarioId
    : selectedScenarioSlice?.scenario_id;
  const [baseCompetitorKpis, setBaseCompetitorKpis] = useState();
  const [
    cyclesWithCompetitorScenarios,
    setCyclesWithCompetitorScenarios,
  ] = useState([]);

  // We need to check what scenarios have cycle_id = 4 to only
  // show these in cycle selector
  useEffect(() => {
    const fetchCyclesWithCompetitorScenarios = async () => {
      const result = await athenaClient({
        method: "GET",
        url: buildRequestUrl(
          {
            group_by: "cycle_id",
            scenario_type_id: 4,
          },
          `scenarios`
        ),
      });
      setCyclesWithCompetitorScenarios(result.data);
    };

    fetchCyclesWithCompetitorScenarios();
  }, []);

  return (
    <CardComponent
      isCompetitors
      customStyle={classes.scrolleableContainer}
      title={
        <Typography variant="body1" className={classes.componentTitle}>
          My scenario
        </Typography>
      }
      body={
        <>
          <MainScenarioCardComponent
            setBaseCompetitorScenarioData={setBaseCompetitorScenarioData}
            baseCompetitorKpis={baseCompetitorKpis}
            setBaseCompetitorKpis={setBaseCompetitorKpis}
            cyclesWithCompetitorScenarios={cyclesWithCompetitorScenarios}
          />
          <div className={classes.borderBarTop} />
          <Typography variant="body1" className={classes.componentSecondTitle}>
            Affected By
          </Typography>
          <Box className={classes.CardCompetitorsContainer}>
            <CustomCompetitorsListComponent
              baseCompetitorScenarioData={baseCompetitorScenarioData}
              setBaseCompetitorKpis={setBaseCompetitorKpis}
              mainScenarioId={mainScenarioId}
              cyclesWithCompetitorScenarios={cyclesWithCompetitorScenarios}
            />
          </Box>
        </>
      }
    />
  );
}
